import "98.css";
import { useState, useEffect } from "react"

export default function Calendar({onClose}) {

    useEffect(() => {
        clearActiveWindow();
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="Events"]'));
        
        return () => {
            //console.log('Component will unmount');
        };
    }, []);

    function clearActiveWindow() {
        document.querySelectorAll('.window').forEach(window => {
            window.classList.remove('active');
        })
    }

    function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }

    // function hideContactForm(e) {
    //     var el = e.target;
    //     //console.log(el);
    //     var dataName = el.getAttribute('data-name');
    //     checkTray(el, true);
    //     document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');
    // }

    function reOpen(selector) {
    
        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        var dataName = selector.getAttribute('data-name');
        //console.log(selector)
        //console.log(selector.nodeName)

        //if (selector.nodeName !== 'BUTTON' && (selector.classList.contains('toolbar-button') || selector.parentElement.classList.contains('toolbar-button'))) return;
        if (selector.nodeName === 'BUTTON' && (selector.classList.contains('form-minimise') || selector.classList.contains('form-close'))) return;
        
        //Toolbar tab buttons
        if (selector.nodeName === 'BUTTON' && selector.classList.contains('toolbar-tab')) {
            dataName = selector.getAttribute('data-name');
            if (document.querySelector('.window[data-name="' + dataName + '"]')) {
                selector.ariaSelected = 'true';
                document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
                document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
            }
        } else {
            selector = selector.closest('.window');
            dataName = selector.getAttribute('data-name');
        }

        clearActiveWindow();
        document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
        document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
    }

    // function checkTray(selector, close=false) {
    //     var selector = selector;
    //     //console.log(selector);
    //     var tray = document.querySelector('.tray');
    //     var dataName = selector.getAttribute('data-name');

    //     document.querySelectorAll('.tray button').forEach(item => {
    //         item.removeAttribute('aria-selected');
    //     });
    //     //dataName = '[data-name="' + dataName + '"]';
    
    //     //console.log(dataName)
    //     if (!tray.querySelector('[data-name="' + dataName + '"]')) {
    //         //console.log('not in tray, add it!')

    //         document.querySelectorAll('.tray button').forEach(item => {
    //             item.ariaSelected = 'false';
    //         });
    
    //         var el = document.createElement('button');
    //         el.role = "tab";
    //         el.innerText = dataName;
    //         //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
    //         el.ariaSelected = "true";
    //         el.setAttribute('data-name', dataName);
    //         el.onclick = reOpen;
    //         document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

    //         document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
    //     } else if (!close) {
            
    //         document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
    //     } else {
    //         //console.log('already in tray');
    //         tray.querySelector('[data-name="' + dataName + '"]').remove();
    //     }
    // }

    return (
        <>

        <div className="window active" data-name="Events" onClick={reOpen}>

            <div className="title-bar">
                <div className="title-bar-text">Event Calendar</div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="Events"></button>
                    <button className="form-close" aria-label="Close" onClick={onClose} data-name="Events"></button>
                </div>
            </div>
            <div className="window-body">
                <div className="events-wrapper">
                    <div className="events-container">
                        <div className="events-header">
                            <h2>Events Calendar</h2>
                            <img src="/images/social_logos_cropped/calendar.png" alt="calendar icon"></img>
                        </div>
                        <ol className="event-list">
                            <li className="event-list-item">
                                <a href="https://ra.co/events/2175277" target="_blank" rel="noreferrer">
                                    <div className="event-content">
                                        <p className="event-title bold">Dance Practice Live 1</p>
                                        <p>We'll be kicking off the party at Avalon Cafe on the 10th July, opening up for Pax and Shoko Yoshida</p>
                                    </div>
                                    <div className="date">
                                        <span className="month">Jul<br></br>
                                            <span>10
                                                <span className="year">'25</span>
                                            </span>
                                        </span>
                                    </div>
                                </a>
                            </li>
                            <li className="event-list-item">
                                <a href="https://studio91.net/" target="_blank" rel="noreferrer">
                                    <div className="event-content">
                                        <p className="event-title bold">Studio with SAM</p>
                                        <p>New music...</p>
                                    </div>
                                    <div className="date">
                                        <span className="month">Aug<br></br>
                                            <span>16
                                                <span className="year">'25</span>
                                            </span>
                                        </span>
                                    </div>
                                </a>
                            </li>
                        </ol>
                        <div className="separator">
                            <span className="line"></span>
                            <h4> Past Events </h4>
                            <span className="line"></span>
                        </div>
                        <ol className="event-list">
                            <li className="event-list-item">
                                <a href="https://ditto.fm/songs-about-love-and-money" target="_blank" rel="noreferrer">
                                    <div className="event-content">
                                        <p className="event-title bold">Songs About Love and Money EP Release</p>
                                        <p>The debut EP featuring 'I Took a Trip' releases on all streaming platforms.</p>
                                    </div>
                                    <div className="date">
                                        <span className="month">June<br></br>
                                            <span>20
                                                <span className="year">'25</span>
                                            </span>
                                        </span>
                                    </div>
                                </a>
                            </li>
                            <li className="event-list-item">
                                <a target="_blank" rel="noreferrer">
                                    <div className="event-content">
                                        <p className="event-title bold">Dream Bags Jaguar Shoes</p>
                                        <p>Our second installment at Dream Bags Jaguar Shoes, featuring the talented Georgia Morgan Turner and Balint Eckhardt.</p>
                                    </div>
                                    <div className="date">
                                        <span className="month">May<br></br>
                                            <span>10
                                                <span className="year">'25</span>
                                            </span>
                                        </span>
                                    </div>
                                </a>
                            </li>
                            <li className="event-list-item">
                                <a target="_blank" rel="noreferrer">
                                    <div className="event-content">
                                        <p className="event-title bold">A Night at the Casino</p>
                                        <p>Be Lucky's debut show hosted at The Victoria, Dalston. Dress like you mean it and come ready to dance.</p>
                                    </div>
                                    <div className="date">
                                        <span className="month">Jan<br></br>
                                            <span>24
                                                <span className="year">'25</span>
                                            </span>
                                        </span>
                                    </div>
                                </a>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        </> 
    )
}